import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./5.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 329.4 363.4"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            id="_1A_2501"
            data-name="1A_2501"
            points="292.2 97.8 292.2 124.8 276.7 124.8 276.7 119.6 265.5 119.6 265.5 97.7 292.2 97.8"
            fill="#231f20"
          />
          <polygon
            id="_1A_2504"
            data-name="1A_2504"
            points="198.2 124.8 198.2 119.6 186.7 119.6 186.7 97.7 212.9 97.7 212.9 124.9 198.2 124.8"
            fill="#231f20"
          />
          <polygon
            id="_1A_2507"
            data-name="1A_2507"
            points="107.4 97.7 134.4 97.7 134.4 124.7 119.6 124.7 119.6 119.6 107.4 119.6 107.4 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1A_2508"
            data-name="1A_2508"
            points="72.6 132.5 99.7 132.5 99.7 148 94.6 148 94.6 159.4 72.6 159.4 72.6 132.5"
            fill="#231f20"
          />
          <polygon
            id="_1A_2510"
            data-name="1A_2510"
            points="99.8 200.4 94.6 200.4 94.6 211.8 72.6 211.8 72.6 185.6 99.9 185.6 99.8 200.4"
            fill="#231f20"
          />
          <polygon
            id="_1A_2513"
            data-name="1A_2513"
            points="99.8 279.1 94.5 279.1 94.5 290.3 72.6 290.3 72.6 264.2 99.7 264.2 99.8 279.1"
            fill="#231f20"
          />
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            id="_1Bx_2502"
            data-name="1Bx_2502"
            points="239.1 97.7 265.3 97.7 265.3 129.1 250.3 129.1 250.3 124.8 239.1 124.8 239.1 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2503"
            data-name="1Cx_2503"
            points="212.9 97.7 239.1 97.7 239.1 133.9 224.1 133.9 224.1 129.6 212.9 129.6 212.9 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2505"
            data-name="1Bx_2505"
            points="160.5 97.7 186.7 97.7 186.7 129.2 171.7 129.2 171.7 125.1 160.5 125.1 160.5 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2506"
            data-name="1Cx_2506"
            points="134.4 97.7 160.4 97.7 160.4 133.9 145.5 133.9 145.5 129.8 134.4 129.8 134.4 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2509"
            data-name="1Cx_2509"
            points="72.6 159.4 108.8 159.4 108.8 174.4 104.5 174.4 104.5 185.6 72.6 185.6 72.6 159.4"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2511"
            data-name="1Bx_2511"
            points="72.6 211.8 104.1 211.8 104.1 226.8 99.8 226.8 99.8 238 72.6 238 72.6 211.8"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2512"
            data-name="1Cx_2512"
            points="108.9 238 108.9 252.8 104.5 252.8 104.5 264.2 72.6 264.2 72.6 238 108.9 238"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2514"
            data-name="1Bx_2514"
            points="104.1 290.3 104.1 305.4 100 305.4 100 317.3 72.6 317.3 72.6 290.4 104.1 290.3"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2515"
            data-name="1Bx_2515"
            points="65 237.8 65 264.9 34.1 264.9 34.1 249.1 38.2 249.1 38.2 238 65 237.8"
            fill="#231f20"
          />
          <polygon
            id="_1B_2516"
            data-name="1B_2516"
            points="38.3 212.3 65.5 212.3 65.5 237.8 37.9 237.8 37.9 212.1 38.3 212.3"
            fill="#231f20"
          />
          <polygon
            id="_1D_2519"
            data-name="1D_2519"
            points="35.1 117.2 46.9 105.5 50.6 109.2 58.5 101.3 74 116.7 65.5 125.3 65.5 133.2 38.8 133.2 38.8 121 35.1 117.2"
            fill="#231f20"
          />
          <polygon
            id="_1D_2520"
            data-name="1D_2520"
            points="80.4 72 92.2 60.2 95.9 63.9 108.1 63.9 108.1 90.4 100.2 90.5 92.5 98.1 77.2 82.7 84.1 75.8 80.4 72"
            fill="#231f20"
          />
          <polygon
            id="_1C_2523"
            data-name="1C_2523"
            points="186.7 58.6 212.9 58.6 212.9 90.5 186.7 90.4 186.7 58.6"
            fill="#231f20"
          />
          <rect
            id="_1C_2524"
            data-name="1C_2524"
            x="212.9"
            y="58.6"
            width="26.2"
            height="31.9"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            id="_2Bx1_2522"
            data-name="2Bx1_2522"
            points="147.4 58.6 174.3 58.6 174.3 63.4 186.6 63.4 186.6 90.5 147.4 90.5 147.4 58.6"
            fill="#231f20"
          />
          <polygon
            id="_2Bx2_2521"
            data-name="2Bx2_2521"
            points="108.1 58.6 135.1 58.6 135.1 63.4 147.4 63.4 147.4 90.5 108.1 90.5 108.1 58.6"
            fill="#231f20"
          />
          <rect
            id="_2B1_2518"
            data-name="2B1_2518"
            x="38.3"
            y="133.2"
            width="27.1"
            height="39.29"
            fill="#231f20"
          />
          <polygon
            id="_2Bx2_2517"
            data-name="2Bx2_2517"
            points="33.6 184.9 38.3 184.9 38.3 172.5 65.5 172.5 65.5 212.3 33.6 212.3 33.6 184.9"
            fill="#231f20"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(271.5 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2501
          </text>
          <text
            transform="translate(246 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2502
          </text>
          <text
            transform="translate(220 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2503
          </text>
          <text
            transform="translate(193.7 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2504
          </text>
          <text
            transform="translate(167.9 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2505
          </text>
          <text
            transform="translate(141.9 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2506
          </text>
          <text
            transform="translate(115.5 134.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2507
          </text>
          <text
            transform="translate(106 150.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2508
          </text>
          <text
            transform="translate(111.5 176.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2509
          </text>
          <text
            transform="translate(111.5 203)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2510
          </text>
          <text
            transform="translate(111.5 228.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2511
          </text>
          <text
            transform="translate(111.5 254.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2512
          </text>
          <text
            transform="translate(111.5 280.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2513
          </text>
          <text
            transform="translate(111.5 307.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2514
          </text>
          <text
            transform="translate(69.8 66.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2520
          </text>
          <text
            transform="translate(27.8 106.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2519
          </text>
          <text
            transform="translate(120.6 49.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2521
          </text>
          <text
            transform="translate(159.8 49.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2522
          </text>
          <text
            transform="translate(193.8 49.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2523
          </text>
          <text
            transform="translate(219.7 49.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2524
          </text>
          <text
            transform="translate(11.4 157.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2518
          </text>
          <text
            transform="translate(11.4 195.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2517
          </text>
          <text
            transform="translate(11.4 228.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2516
          </text>
          <text
            transform="translate(11.4 254.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2515
          </text>
          <text
            transform="translate(182.9 217.7)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            <tspan font-weight="700">5</tspan>
            <tspan
              x="5.1"
              y="0"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              楼
            </tspan>
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(271.4 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2501
          </text>
          <text
            transform="translate(245.9 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2502
          </text>
          <text
            transform="translate(219.9 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2503
          </text>
          <text
            transform="translate(193.6 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2504
          </text>
          <text
            transform="translate(167.8 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2505
          </text>
          <text
            transform="translate(141.8 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2506
          </text>
          <text
            transform="translate(115.5 134.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2507
          </text>
          <text
            transform="translate(105.9 150.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2508
          </text>
          <text
            transform="translate(111.4 176.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2509
          </text>
          <text
            transform="translate(111.4 203)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2510
          </text>
          <text
            transform="translate(111.4 228.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2511
          </text>
          <text
            transform="translate(111.4 254.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2512
          </text>
          <text
            transform="translate(111.4 280.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2513
          </text>
          <text
            transform="translate(111.4 307.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2514
          </text>
          <text
            transform="translate(69.7 66.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2520
          </text>
          <text
            transform="translate(27.7 106.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2519
          </text>
          <text
            transform="translate(120.5 49.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2521
          </text>
          <text
            transform="translate(159.7 49.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2522
          </text>
          <text
            transform="translate(193.7 49.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2523
          </text>
          <text
            transform="translate(219.6 49.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2524
          </text>
          <text
            transform="translate(11.3 157.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2518
          </text>
          <text
            transform="translate(11.3 195.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2517
          </text>
          <text
            transform="translate(11.3 228.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2516
          </text>
          <text
            transform="translate(11.3 254.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2515
          </text>
          <text
            transform="translate(175 217.7)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            5-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(271.5 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2501
          </text>
          <text
            transform="translate(246 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2502
          </text>
          <text
            transform="translate(220 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2503
          </text>
          <text
            transform="translate(193.6 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2504
          </text>
          <text
            transform="translate(167.9 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2505
          </text>
          <text
            transform="translate(141.8 142.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2506
          </text>
          <text
            transform="translate(115.5 134.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2507
          </text>
          <text
            transform="translate(106 150.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2508
          </text>
          <text
            transform="translate(111.5 176.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2509
          </text>
          <text
            transform="translate(111.5 203)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2510
          </text>
          <text
            transform="translate(111.5 228.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2511
          </text>
          <text
            transform="translate(111.5 254.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2512
          </text>
          <text
            transform="translate(111.5 280.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2513
          </text>
          <text
            transform="translate(111.5 307.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2514
          </text>
          <text
            transform="translate(69.7 66.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2520
          </text>
          <text
            transform="translate(27.7 106.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2519
          </text>
          <text
            transform="translate(120.6 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2521
          </text>
          <text
            transform="translate(159.8 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2522
          </text>
          <text
            transform="translate(193.8 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2523
          </text>
          <text
            transform="translate(219.7 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2524
          </text>
          <text
            transform="translate(11.4 157.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2518
          </text>
          <text
            transform="translate(11.4 195.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2517
          </text>
          <text
            transform="translate(11.4 228.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2516
          </text>
          <text
            transform="translate(11.4 254.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2515
          </text>
          <text
            transform="translate(171.7 217.6)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            5th Floot
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/b/5.js